import {
	enableProdMode,
} from '@angular/core';

import { environment } from './environments/environment';
import { AppComponent } from './app/app/app.component';
import {bootstrapApplication} from '@angular/platform-browser';
import { mergedConfig } from './app/app/app.config.client';
if (environment.production) {
	enableProdMode();
}

/*
// Store the original setInterval
const originalSetInterval = window.setInterval;

// Override it to log the stack trace
(window as any).setInterval = (handler: TimerHandler, timeout?: number, ...args: any[]): number => {
  if (timeout !== 0) { // Filter out some potential noise
      console.log('setInterval called with timeout:', timeout);
      console.trace(); // This prints the call stack!
  }
  return originalSetInterval(handler, timeout, ...args);
};
*/

	bootstrapApplication(AppComponent, mergedConfig)
		// eslint-disable-next-line no-console
		.catch((err) => console.error(err));

